// Elite Api
// Get Drawer Data
const getCartDrawerData = async () => {
    try {
        const response = await fetch(window.Shopify.routes.root, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch data: ${response.status} ${response.statusText}`);
        }

        const data = await response.text();
        const parser = new DOMParser();
        const updateDocument = parser.parseFromString(data, 'text/html');

        // Update Table
        const previousDrawerTable = document.querySelector('#main-cart-drawer-items');
        const updateDrawerTable = updateDocument.querySelector('#main-cart-drawer-items');

        // Update Footer
        const previousDrawerFooterTable = document.querySelector('#main-cart-drawer-footer');
        const updateDrawerFooterTable = updateDocument.querySelector('#main-cart-drawer-footer');

        if (previousDrawerTable && updateDrawerTable) {
            previousDrawerTable.innerHTML = updateDrawerTable.innerHTML;
        }

        if (previousDrawerFooterTable && updateDrawerFooterTable) {
            previousDrawerFooterTable.innerHTML = updateDrawerFooterTable.innerHTML;
        }

        return true; // Indicate success
    } catch (error) {
        console.error('Error fetching and updating cart drawer data:', error);
        return false; // Indicate failure
    }
};

// Open & Update Count
const openCart = (count) => {
    document.body.classList.add('overflow-hidden');
    const cart_drawer = document.querySelector('#drawer-cart');
    cart_drawer.classList.remove('translate-x-full');
    cart_drawer.classList.add('translate-none');

    const cart_bubble = document.querySelector('button[data-drawer-target="drawer-cart"]');

    if (cart_bubble) {
        cart_bubble.querySelector('span[aria-hidden="true"]').innerHTML = count;
        cart_bubble.querySelector('span.visually-hidden').innerHTML = `${count} item`;
    }
}

// Get Cart Data
const getCart = async () => {
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch cart data: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching cart data:", error);
        return null; // Return `null` to handle errors gracefully
    }
};

document.addEventListener("DOMContentLoaded", () => {
    const getAllEliteProducts = document.querySelectorAll(
        ".cc-elite-product-api"
    );

    getAllEliteProducts.forEach((item) => {
        item.addEventListener("click", async (e) => {
            console.log("Add to Cart Elite Product");
            // Make the callback async
            e.preventDefault();
            e.target.textContent = "Loading...";

            const id = e.target.dataset.id;
            const formData = {
                items: [
                    {
                        id: +id, // Ensure `id` is a number
                        quantity: 1,
                        properties: { _type: "hide" },
                    },
                ],
            };

            try {
                const response = await fetch(
                    `${window.Shopify.routes.root}cart/add.js`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(formData),
                    }
                );

                if (!response.ok) throw new Error("Failed to add item to cart");

                const get_cart = await getCart();
                const count = get_cart.item_count
                const account_elite_box = e.target.closest(".cc-mm-account-get-elite");
                if (account_elite_box) {
                    account_elite_box.remove();
                }
                const drawer_cart = await getCartDrawerData()

                if (drawer_cart) {
                    openCart(count); // Open the cart
                }
  

                const data = await response.json();
                // window.location.href = "/cart";
            } catch (error) {
                console.error("Error adding item to cart:", error);
                e.target.textContent = "Error, try again";
            } finally {
                e.target.textContent = "JOIN NOW";
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const accept_elite = document.querySelector("#accept_policy");

    if (accept_elite) {
        accept_elite.addEventListener("click", async () => {
            const id = accept_elite.value;
console.log("Elite Policy");
            if (accept_elite.checked) {
              console.log("Elite Policy");
              
                // Add product to cart
                // const formData = {
                //     items: [
                //         {
                //             id: +id, // Ensure this ID is dynamically replaced
                //             quantity: 1,
                //             properties: { _type: "hide" },
                //         },
                //     ],
                // };

                // try {
                //     const response = await fetch(
                //         window.Shopify.routes.root + "cart/add.js",
                //         {
                //             method: "POST",
                //             headers: {
                //                 "Content-Type": "application/json",
                //             },
                //             body: JSON.stringify(formData),
                //         }
                //     );

                //     if (!response.ok) throw new Error("Failed to add item to cart");

                //     const data = await response.json();
                //     console.log("Item added to cart:", data);
                // } catch (error) {
                //     console.error("Error adding item to cart:", error);
                // }
            } else {
                // const updates = { [id]: 0 }; // Proper syntax for dynamic object keys

                // try {
                //     const response = await fetch(
                //         window.Shopify.routes.root + "cart/update.js",
                //         {
                //             method: "POST",
                //             headers: {
                //                 "Content-Type": "application/json",
                //             },
                //             body: JSON.stringify({ updates }),
                //         }
                //     );

                //     if (!response.ok) throw new Error("Failed to remove item from cart");

                //     const data = await response.json();
                //     console.log("Item removed from cart:", data);
                // } catch (error) {
                //     console.error("Error removing item from cart:", error);
                // }
            }
        });
    } else {
        console.warn("Checkbox with ID 'accept_policy' not found.");
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const details_button = document.querySelectorAll(".cc-sites-access-button");

    details_button.forEach((item) => {
        item.addEventListener("click", (e) => {
            e.preventDefault();

            const content = JSON.parse(item.dataset.content);

            // Generate the HTML for the popup
            const template = `
          <div class="cc-site-popup-block">
            <button class="cc-site-popup-close-button" onclick="closePopup()">
              <img src="https://cdn.shopify.com/s/files/1/0925/7290/files/close-button.png" class="img-responsive" />
            </button>
            <div class="cc-site-popup-content">
              <div class="cc-site-popup-logo">
                <img src="${content.logo}" class="img-responsive" />
              </div>
              <div class="cc-site-popup-list">
                <h3>${content.club.heading}</h3>
                <ul>
                  ${content.club.list
                    .map(
                        (item) => `
                      <li>
                        <img src="https://cdn.shopify.com/s/files/1/0925/7290/files/red-tick.png?v=1732415833" class="img-responsive" />
                        <span>${item}</span>
                      </li>`
                    )
                    .join("")}
                </ul>
              </div>
              <div class="cc-site-popup-list">
                <h3>${content.elite.heading}</h3>
                <ul>
                  ${content.elite.list
                    .map(
                        (item) => `
                      <li>
                        <img src="https://cdn.shopify.com/s/files/1/0925/7290/files/blue-tick.png?v=1732415833" class="img-responsive" />
                        <span>${item}</span>
                      </li>`
                    )
                    .join("")}
                </ul>
              </div>
            </div>
             <button class="cc-site-popup-close-button-text" onclick="closePopup()">Close</button>
          </div>
        `;

            // Append the popup to the body
            document.body.insertAdjacentHTML("afterbegin", template);
        });
    });
});

// Function to close the popup
function closePopup() {
    const popup = document.querySelector(".cc-site-popup-block");
    if (popup) {
        popup.remove();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const productSlider = document.querySelectorAll(".cc-products-slider");

    if (productSlider.length > 0) {
        productSlider.forEach((slider) => {
            new Splide(slider, {
                perPage: 3,
                gap: "26px",
                rewind: true,
                arrows: false,
                pagination: false,
                breakpoints: {
                    1200: {
                        perPage: 2,
                    },
                    800: {
                        type: "loop",
                        padding: "15%",
                        perPage: 1,
                    },
                },
            }).mount();
        });
    }

    const sitesSlider = document.querySelectorAll(".cc-sites-slider");

    if (sitesSlider.length > 0) {
        sitesSlider.forEach((slider) => {
            new Splide(slider, {
                perPage: 4,
                gap: "24px",
                rewind: true,
                arrows: false,
                pagination: false,
                breakpoints: {
                    1200: {
                        perPage: 2,
                    },
                    800: {
                        type: "loop",
                        padding: "15%",
                        perPage: 1,
                    },
                },
            }).mount();
        });
    }
});